var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c6ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ac5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 34,
    height: 34,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(7.385 3.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(-62.385 -46.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(55 43)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M34,12.887v.539a1.794,1.794,0,0,1-.838.814c-.572.317-1.127.665-1.7.985a.319.319,0,0,0-.17.347q.019,1.427,0,2.855a.32.32,0,0,0,.171.347c.57.321,1.125.669,1.7.986a1.79,1.79,0,0,1,.838.814v.539c-.06.1-.12.208-.179.312Q31.509,25.493,29.2,29.56a1,1,0,0,1-1.521.4c-.633-.368-1.267-.735-1.893-1.114a.334.334,0,0,0-.411.016c-.8.483-1.6.955-2.411,1.406a.392.392,0,0,0-.247.407c.012.741.008,1.483,0,2.224A.994.994,0,0,1,21.647,34Q17,34,12.353,34A.993.993,0,0,1,11.284,32.9c0-.742-.008-1.483,0-2.224a.4.4,0,0,0-.246-.409q-1.219-.678-2.411-1.406a.334.334,0,0,0-.411-.012c-.588.356-1.185.7-1.779,1.046a1.054,1.054,0,0,1-1.7-.454L0,21.113v-.539a1.76,1.76,0,0,1,.81-.8c.573-.314,1.128-.664,1.7-.983.174-.1.2-.208.193-.4Q2.674,17,2.7,15.606c0-.192-.018-.3-.192-.4-.571-.319-1.125-.669-1.7-.983a1.77,1.77,0,0,1-.81-.8v-.539l.211-.372Q2.5,8.492,4.788,4.468a1.007,1.007,0,0,1,1.537-.431c.634.366,1.268.732,1.895,1.112a.333.333,0,0,0,.41-.013c.8-.482,1.6-.953,2.412-1.406a.4.4,0,0,0,.246-.409c-.012-.741-.007-1.483,0-2.224A.993.993,0,0,1,12.353,0Q17,0,21.648,0A.993.993,0,0,1,22.716,1.1c0,.742.009,1.483,0,2.224a.393.393,0,0,0,.248.406q1.219.679,2.411,1.407a.333.333,0,0,0,.41.016c.579-.351,1.166-.688,1.75-1.031.811-.476,1.285-.35,1.748.465L34,12.887m-23.271-1.28a1.182,1.182,0,0,0-1.132.831q-1.61,4.27-3.208,8.545a1.019,1.019,0,0,0,.551,1.339.99.99,0,0,0,1.31-.631c.161-.405.317-.813.458-1.226a.3.3,0,0,1,.338-.231c1.106.009,2.212.012,3.317,0a.337.337,0,0,1,.374.279,10.324,10.324,0,0,0,.435,1.162,1.554,1.554,0,0,0,.472.579.9.9,0,0,0,1.108-.095A1.014,1.014,0,0,0,15.039,21c-.335-.926-.683-1.846-1.026-2.769q-1.064-2.862-2.128-5.725a1.211,1.211,0,0,0-1.155-.9m7.606,6.953c.572,0,1.1.019,1.628,0a3.468,3.468,0,0,0,3.264-3.326,3.417,3.417,0,0,0-2.895-3.548,25.052,25.052,0,0,0-2.914-.072,1,1,0,0,0-1.071,1.067q-.011,4.329.006,8.659a1.308,1.308,0,0,0,.213.654.913.913,0,0,0,1.055.357.965.965,0,0,0,.711-.946c.009-.92,0-1.84,0-2.84M26.5,17.035q0-2.155,0-4.31a1,1,0,1,0-1.991.014q0,4.259,0,8.519a1.005,1.005,0,1,0,1.991-.014q0-2.1,0-4.209",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M110.33,170.876h-2.309l1.159-3.1,1.15,3.1",
    transform: "translate(-98.457 -152.67)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M207.372,154.223v-2.9a14.44,14.44,0,0,1,1.621.012,1.458,1.458,0,0,1,1.255,1.5,1.478,1.478,0,0,1-1.412,1.385c-.472.021-.946,0-1.464,0",
    transform: "translate(-189.011 -137.68)",
    fill: "url(#linear-gradient)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.d1074b5ee81c8f7eacd4a80dc8a03613.svg";
export { ForwardRef as ReactComponent };